export class KKItem {
  
  
  static l = [
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36",
      "ItemNumber": "550-LOPRM36",
      "LongItemNumber": "550-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "550-LOPRM36TR",
      "LongItemNumber": "550-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72",
      "ItemNumber": "550-PBHCR72",
      "LongItemNumber": "550-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "550-PBHCR72TR",
      "LongItemNumber": "550-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72",
      "ItemNumber": "550-PBHMS72",
      "LongItemNumber": "550-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "550-PBHMS72TR",
      "LongItemNumber": "550-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72",
      "ItemNumber": "550-PBHPNL72",
      "LongItemNumber": "550-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "550-PBHPNL72TR",
      "LongItemNumber": "550-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72",
      "ItemNumber": "550-PBHRM72",
      "LongItemNumber": "550-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "550-PBHRM72TR",
      "LongItemNumber": "550-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72",
      "ItemNumber": "550-PCEMS72",
      "LongItemNumber": "550-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "550-PCEMS72TR",
      "LongItemNumber": "550-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72",
      "ItemNumber": "550-PCGHCR72",
      "LongItemNumber": "550-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "550-PCGHCR72TR",
      "LongItemNumber": "550-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72",
      "ItemNumber": "550-PCGHMS72",
      "LongItemNumber": "550-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "550-PCGHMS72TR",
      "LongItemNumber": "550-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "550-PCGHPNL72",
      "LongItemNumber": "550-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "550-PCGHPNL72TR",
      "LongItemNumber": "550-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72",
      "ItemNumber": "550-PCGHRM72",
      "LongItemNumber": "550-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "550-PCGHRM72TR",
      "LongItemNumber": "550-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72",
      "ItemNumber": "550-POPCR72",
      "LongItemNumber": "550-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPCR72TR",
      "ItemNumber": "550-POPCR72TR",
      "LongItemNumber": "550-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72",
      "ItemNumber": "550-POPMS72",
      "LongItemNumber": "550-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPMS72TR",
      "ItemNumber": "550-POPMS72TR",
      "LongItemNumber": "550-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72",
      "ItemNumber": "550-POPPNL72",
      "LongItemNumber": "550-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "550-POPPNL72TR",
      "LongItemNumber": "550-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72",
      "ItemNumber": "550-POPRM72",
      "LongItemNumber": "550-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "POPRM72TR",
      "ItemNumber": "550-POPRM72TR",
      "LongItemNumber": "550-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36",
      "ItemNumber": "550-RBHCR36",
      "LongItemNumber": "550-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "550-RBHCR36TR",
      "LongItemNumber": "550-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36",
      "ItemNumber": "550-RBHMS36",
      "LongItemNumber": "550-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "550-RBHMS36TR",
      "LongItemNumber": "550-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42",
      "ItemNumber": "550-RBHMS42",
      "LongItemNumber": "550-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "550-RBHMS42TR",
      "LongItemNumber": "550-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36",
      "ItemNumber": "550-RBHPNL36",
      "LongItemNumber": "550-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "550-RBHPNL36TR",
      "LongItemNumber": "550-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36",
      "ItemNumber": "550-RBHRM36",
      "LongItemNumber": "550-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "550-RBHRM36TR",
      "LongItemNumber": "550-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36",
      "ItemNumber": "550-RCGHCR36",
      "LongItemNumber": "550-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "550-RCGHCR36TR",
      "LongItemNumber": "550-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36",
      "ItemNumber": "550-RCGHMS36",
      "LongItemNumber": "550-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "550-RCGHMS36TR",
      "LongItemNumber": "550-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42",
      "ItemNumber": "550-RCGHMS42",
      "LongItemNumber": "550-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "550-RCGHMS42TR",
      "LongItemNumber": "550-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "550-RCGHPNL36",
      "LongItemNumber": "550-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "550-RCGHPNL36TR",
      "LongItemNumber": "550-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36",
      "ItemNumber": "550-RCGHRM36",
      "LongItemNumber": "550-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "550-RCGHRM36TR",
      "LongItemNumber": "550-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36",
      "ItemNumber": "550-ROPCR36",
      "LongItemNumber": "550-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "550-ROPCR36TR",
      "LongItemNumber": "550-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36",
      "ItemNumber": "550-ROPMS36",
      "LongItemNumber": "550-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "550-ROPMS36TR",
      "LongItemNumber": "550-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42",
      "ItemNumber": "550-ROPMS42",
      "LongItemNumber": "550-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "550-ROPMS42TR",
      "LongItemNumber": "550-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36",
      "ItemNumber": "550-ROPPNL36",
      "LongItemNumber": "550-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "550-ROPPNL36TR",
      "LongItemNumber": "550-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36",
      "ItemNumber": "550-ROPRM36",
      "LongItemNumber": "550-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "550-ROPRM36TR",
      "LongItemNumber": "550-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36",
      "ItemNumber": "550-SCEMS36",
      "LongItemNumber": "550-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "550-SCEMS36TR",
      "LongItemNumber": "550-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42",
      "ItemNumber": "550-SCEMS42",
      "LongItemNumber": "550-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "550-SCEMS42TR",
      "LongItemNumber": "550-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36",
      "ItemNumber": "551-LBHCR36",
      "LongItemNumber": "551-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "551-LBHCR36TR",
      "LongItemNumber": "551-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36",
      "ItemNumber": "551-LBHMS36",
      "LongItemNumber": "551-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "551-LBHMS36TR",
      "LongItemNumber": "551-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42",
      "ItemNumber": "551-LBHMS42",
      "LongItemNumber": "551-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "551-LBHMS42TR",
      "LongItemNumber": "551-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36",
      "ItemNumber": "551-LBHPNL36",
      "LongItemNumber": "551-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "551-LBHPNL36TR",
      "LongItemNumber": "551-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36",
      "ItemNumber": "551-LBHRM36",
      "LongItemNumber": "551-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "551-LBHRM36TR",
      "LongItemNumber": "551-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36",
      "ItemNumber": "551-LCGHCR36",
      "LongItemNumber": "551-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "551-LCGHCR36TR",
      "LongItemNumber": "551-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36",
      "ItemNumber": "551-LCGHMS36",
      "LongItemNumber": "551-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "551-LCGHMS36TR",
      "LongItemNumber": "551-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42",
      "ItemNumber": "551-LCGHMS42",
      "LongItemNumber": "551-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "551-LCGHMS42TR",
      "LongItemNumber": "551-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "551-LCGHPNL36",
      "LongItemNumber": "551-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "551-LCGHPNL36TR",
      "LongItemNumber": "551-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36",
      "ItemNumber": "551-LCGHRM36",
      "LongItemNumber": "551-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "551-LCGHRM36TR",
      "LongItemNumber": "551-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36",
      "ItemNumber": "551-LOPCR36",
      "LongItemNumber": "551-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "551-LOPCR36TR",
      "LongItemNumber": "551-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36",
      "ItemNumber": "551-LOPMS36",
      "LongItemNumber": "551-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "551-LOPMS36TR",
      "LongItemNumber": "551-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42",
      "ItemNumber": "551-LOPMS42",
      "LongItemNumber": "551-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "551-LOPMS42TR",
      "LongItemNumber": "551-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36",
      "ItemNumber": "551-LOPPNL36",
      "LongItemNumber": "551-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "551-LOPPNL36TR",
      "LongItemNumber": "551-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36",
      "ItemNumber": "551-LOPRM36",
      "LongItemNumber": "551-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "551-LOPRM36TR",
      "LongItemNumber": "551-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72",
      "ItemNumber": "551-PBHCR72",
      "LongItemNumber": "551-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "551-PBHCR72TR",
      "LongItemNumber": "551-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72",
      "ItemNumber": "551-PBHMS72",
      "LongItemNumber": "551-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "551-PBHMS72TR",
      "LongItemNumber": "551-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72",
      "ItemNumber": "551-PBHPNL72",
      "LongItemNumber": "551-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "551-PBHPNL72TR",
      "LongItemNumber": "551-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72",
      "ItemNumber": "551-PBHRM72",
      "LongItemNumber": "551-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "551-PBHRM72TR",
      "LongItemNumber": "551-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72",
      "ItemNumber": "551-PCEMS72",
      "LongItemNumber": "551-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "551-PCEMS72TR",
      "LongItemNumber": "551-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72",
      "ItemNumber": "551-PCGHCR72",
      "LongItemNumber": "551-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "551-PCGHCR72TR",
      "LongItemNumber": "551-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72",
      "ItemNumber": "551-PCGHMS72",
      "LongItemNumber": "551-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "551-PCGHMS72TR",
      "LongItemNumber": "551-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "551-PCGHPNL72",
      "LongItemNumber": "551-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "551-PCGHPNL72TR",
      "LongItemNumber": "551-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72",
      "ItemNumber": "551-PCGHRM72",
      "LongItemNumber": "551-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "551-PCGHRM72TR",
      "LongItemNumber": "551-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72",
      "ItemNumber": "551-POPCR72",
      "LongItemNumber": "551-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPCR72TR",
      "ItemNumber": "551-POPCR72TR",
      "LongItemNumber": "551-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72",
      "ItemNumber": "551-POPMS72",
      "LongItemNumber": "551-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPMS72TR",
      "ItemNumber": "551-POPMS72TR",
      "LongItemNumber": "551-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72",
      "ItemNumber": "551-POPPNL72",
      "LongItemNumber": "551-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "551-POPPNL72TR",
      "LongItemNumber": "551-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72",
      "ItemNumber": "551-POPRM72",
      "LongItemNumber": "551-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "POPRM72TR",
      "ItemNumber": "551-POPRM72TR",
      "LongItemNumber": "551-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36",
      "ItemNumber": "551-RBHCR36",
      "LongItemNumber": "551-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "551-RBHCR36TR",
      "LongItemNumber": "551-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36",
      "ItemNumber": "551-RBHMS36",
      "LongItemNumber": "551-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "551-RBHMS36TR",
      "LongItemNumber": "551-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42",
      "ItemNumber": "551-RBHMS42",
      "LongItemNumber": "551-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "551-RBHMS42TR",
      "LongItemNumber": "551-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36",
      "ItemNumber": "551-RBHPNL36",
      "LongItemNumber": "551-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "551-RBHPNL36TR",
      "LongItemNumber": "551-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36",
      "ItemNumber": "551-RBHRM36",
      "LongItemNumber": "551-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "551-RBHRM36TR",
      "LongItemNumber": "551-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36",
      "ItemNumber": "551-RCGHCR36",
      "LongItemNumber": "551-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "551-RCGHCR36TR",
      "LongItemNumber": "551-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36",
      "ItemNumber": "551-RCGHMS36",
      "LongItemNumber": "551-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "551-RCGHMS36TR",
      "LongItemNumber": "551-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42",
      "ItemNumber": "551-RCGHMS42",
      "LongItemNumber": "551-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "551-RCGHMS42TR",
      "LongItemNumber": "551-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "551-RCGHPNL36",
      "LongItemNumber": "551-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "551-RCGHPNL36TR",
      "LongItemNumber": "551-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36",
      "ItemNumber": "551-RCGHRM36",
      "LongItemNumber": "551-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "551-RCGHRM36TR",
      "LongItemNumber": "551-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36",
      "ItemNumber": "551-ROPCR36",
      "LongItemNumber": "551-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "551-ROPCR36TR",
      "LongItemNumber": "551-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36",
      "ItemNumber": "551-ROPMS36",
      "LongItemNumber": "551-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "551-ROPMS36TR",
      "LongItemNumber": "551-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42",
      "ItemNumber": "551-ROPMS42",
      "LongItemNumber": "551-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "551-ROPMS42TR",
      "LongItemNumber": "551-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36",
      "ItemNumber": "551-ROPPNL36",
      "LongItemNumber": "551-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "551-ROPPNL36TR",
      "LongItemNumber": "551-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36",
      "ItemNumber": "551-ROPRM36",
      "LongItemNumber": "551-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "551-ROPRM36TR",
      "LongItemNumber": "551-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36",
      "ItemNumber": "551-SCEMS36",
      "LongItemNumber": "551-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "551-SCEMS36TR",
      "LongItemNumber": "551-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42",
      "ItemNumber": "551-SCEMS42",
      "LongItemNumber": "551-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 551,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "551-SCEMS42TR",
      "LongItemNumber": "551-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHCR36",
      "ItemNumber": "190-LBHCR36",
      "LongItemNumber": "190-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS36",
      "ItemNumber": "190-LBHMS36",
      "LongItemNumber": "190-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHMS42",
      "ItemNumber": "190-LBHMS42",
      "LongItemNumber": "190-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHPNL36",
      "ItemNumber": "190-LBHPNL36",
      "LongItemNumber": "190-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LBHRM36",
      "ItemNumber": "190-LBHRM36",
      "LongItemNumber": "190-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS36",
      "ItemNumber": "190-LCEMS36",
      "LongItemNumber": "190-LCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCEMS42",
      "ItemNumber": "190-LCEMS42",
      "LongItemNumber": "190-LCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHCR36",
      "ItemNumber": "190-LCGHCR36",
      "LongItemNumber": "190-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS36",
      "ItemNumber": "190-LCGHMS36",
      "LongItemNumber": "190-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHMS42",
      "ItemNumber": "190-LCGHMS42",
      "LongItemNumber": "190-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "190-LCGHPNL36",
      "LongItemNumber": "190-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCGHRM36",
      "ItemNumber": "190-LCGHRM36",
      "LongItemNumber": "190-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS36",
      "ItemNumber": "190-LCSMS36",
      "LongItemNumber": "190-LCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LCSMS42",
      "ItemNumber": "190-LCSMS42",
      "LongItemNumber": "190-LCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPCR36",
      "ItemNumber": "190-LOPCR36",
      "LongItemNumber": "190-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS36",
      "ItemNumber": "190-LOPMS36",
      "LongItemNumber": "190-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPMS42",
      "ItemNumber": "190-LOPMS42",
      "LongItemNumber": "190-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPPNL36",
      "ItemNumber": "190-LOPPNL36",
      "LongItemNumber": "190-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "LOPRM36",
      "ItemNumber": "190-LOPRM36",
      "LongItemNumber": "190-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHCR72",
      "ItemNumber": "190-PBHCR72",
      "LongItemNumber": "190-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHMS72",
      "ItemNumber": "190-PBHMS72",
      "LongItemNumber": "190-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHPNL72",
      "ItemNumber": "190-PBHPNL72",
      "LongItemNumber": "190-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PBHRM72",
      "ItemNumber": "190-PBHRM72",
      "LongItemNumber": "190-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCEMS72",
      "ItemNumber": "190-PCEMS72",
      "LongItemNumber": "190-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHCR72",
      "ItemNumber": "190-PCGHCR72",
      "LongItemNumber": "190-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHMS72",
      "ItemNumber": "190-PCGHMS72",
      "LongItemNumber": "190-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "190-PCGHPNL72",
      "LongItemNumber": "190-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCGHRM72",
      "ItemNumber": "190-PCGHRM72",
      "LongItemNumber": "190-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "PCSMS72",
      "ItemNumber": "190-PCSMS72",
      "LongItemNumber": "190-PCSMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPCR72",
      "ItemNumber": "190-POPCR72",
      "LongItemNumber": "190-POPCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPMS72",
      "ItemNumber": "190-POPMS72",
      "LongItemNumber": "190-POPMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPPNL72",
      "ItemNumber": "190-POPPNL72",
      "LongItemNumber": "190-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "POPRM72",
      "ItemNumber": "190-POPRM72",
      "LongItemNumber": "190-POPRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHCR36",
      "ItemNumber": "190-RBHCR36",
      "LongItemNumber": "190-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS36",
      "ItemNumber": "190-RBHMS36",
      "LongItemNumber": "190-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHMS42",
      "ItemNumber": "190-RBHMS42",
      "LongItemNumber": "190-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHPNL36",
      "ItemNumber": "190-RBHPNL36",
      "LongItemNumber": "190-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RBHRM36",
      "ItemNumber": "190-RBHRM36",
      "LongItemNumber": "190-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS36",
      "ItemNumber": "190-RCEMS36",
      "LongItemNumber": "190-RCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCEMS42",
      "ItemNumber": "190-RCEMS42",
      "LongItemNumber": "190-RCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHCR36",
      "ItemNumber": "190-RCGHCR36",
      "LongItemNumber": "190-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS36",
      "ItemNumber": "190-RCGHMS36",
      "LongItemNumber": "190-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHMS42",
      "ItemNumber": "190-RCGHMS42",
      "LongItemNumber": "190-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "190-RCGHPNL36",
      "LongItemNumber": "190-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCGHRM36",
      "ItemNumber": "190-RCGHRM36",
      "LongItemNumber": "190-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS36",
      "ItemNumber": "190-RCSMS36",
      "LongItemNumber": "190-RCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "RCSMS42",
      "ItemNumber": "190-RCSMS42",
      "LongItemNumber": "190-RCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPCR36",
      "ItemNumber": "190-ROPCR36",
      "LongItemNumber": "190-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS36",
      "ItemNumber": "190-ROPMS36",
      "LongItemNumber": "190-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPMS42",
      "ItemNumber": "190-ROPMS42",
      "LongItemNumber": "190-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPPNL36",
      "ItemNumber": "190-ROPPNL36",
      "LongItemNumber": "190-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 190,
      "Option Code": "ROPRM36",
      "ItemNumber": "190-ROPRM36",
      "LongItemNumber": "190-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHCR36",
      "ItemNumber": "350-LBHCR36",
      "LongItemNumber": "350-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS36",
      "ItemNumber": "350-LBHMS36",
      "LongItemNumber": "350-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHMS42",
      "ItemNumber": "350-LBHMS42",
      "LongItemNumber": "350-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHPNL36",
      "ItemNumber": "350-LBHPNL36",
      "LongItemNumber": "350-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LBHRM36",
      "ItemNumber": "350-LBHRM36",
      "LongItemNumber": "350-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS36",
      "ItemNumber": "350-LCEMS36",
      "LongItemNumber": "350-LCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCEMS42",
      "ItemNumber": "350-LCEMS42",
      "LongItemNumber": "350-LCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHCR36",
      "ItemNumber": "350-LCGHCR36",
      "LongItemNumber": "350-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS36",
      "ItemNumber": "350-LCGHMS36",
      "LongItemNumber": "350-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHMS42",
      "ItemNumber": "350-LCGHMS42",
      "LongItemNumber": "350-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "350-LCGHPNL36",
      "LongItemNumber": "350-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCGHRM36",
      "ItemNumber": "350-LCGHRM36",
      "LongItemNumber": "350-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS36",
      "ItemNumber": "350-LCSMS36",
      "LongItemNumber": "350-LCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LCSMS42",
      "ItemNumber": "350-LCSMS42",
      "LongItemNumber": "350-LCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPCR36",
      "ItemNumber": "350-LOPCR36",
      "LongItemNumber": "350-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS36",
      "ItemNumber": "350-LOPMS36",
      "LongItemNumber": "350-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPMS42",
      "ItemNumber": "350-LOPMS42",
      "LongItemNumber": "350-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPPNL36",
      "ItemNumber": "350-LOPPNL36",
      "LongItemNumber": "350-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "LOPRM36",
      "ItemNumber": "350-LOPRM36",
      "LongItemNumber": "350-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHCR72",
      "ItemNumber": "350-PBHCR72",
      "LongItemNumber": "350-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHMS72",
      "ItemNumber": "350-PBHMS72",
      "LongItemNumber": "350-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHPNL72",
      "ItemNumber": "350-PBHPNL72",
      "LongItemNumber": "350-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PBHRM72",
      "ItemNumber": "350-PBHRM72",
      "LongItemNumber": "350-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCEMS72",
      "ItemNumber": "350-PCEMS72",
      "LongItemNumber": "350-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHCR72",
      "ItemNumber": "350-PCGHCR72",
      "LongItemNumber": "350-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHMS72",
      "ItemNumber": "350-PCGHMS72",
      "LongItemNumber": "350-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "350-PCGHPNL72",
      "LongItemNumber": "350-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCGHRM72",
      "ItemNumber": "350-PCGHRM72",
      "LongItemNumber": "350-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "PCSMS72",
      "ItemNumber": "350-PCSMS72",
      "LongItemNumber": "350-PCSMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPCR72",
      "ItemNumber": "350-POPCR72",
      "LongItemNumber": "350-POPCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPMS72",
      "ItemNumber": "350-POPMS72",
      "LongItemNumber": "350-POPMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPPNL72",
      "ItemNumber": "350-POPPNL72",
      "LongItemNumber": "350-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "POPRM72",
      "ItemNumber": "350-POPRM72",
      "LongItemNumber": "350-POPRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHCR36",
      "ItemNumber": "350-RBHCR36",
      "LongItemNumber": "350-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS36",
      "ItemNumber": "350-RBHMS36",
      "LongItemNumber": "350-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHMS42",
      "ItemNumber": "350-RBHMS42",
      "LongItemNumber": "350-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHPNL36",
      "ItemNumber": "350-RBHPNL36",
      "LongItemNumber": "350-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RBHRM36",
      "ItemNumber": "350-RBHRM36",
      "LongItemNumber": "350-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS36",
      "ItemNumber": "350-RCEMS36",
      "LongItemNumber": "350-RCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCEMS42",
      "ItemNumber": "350-RCEMS42",
      "LongItemNumber": "350-RCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHCR36",
      "ItemNumber": "350-RCGHCR36",
      "LongItemNumber": "350-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS36",
      "ItemNumber": "350-RCGHMS36",
      "LongItemNumber": "350-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHMS42",
      "ItemNumber": "350-RCGHMS42",
      "LongItemNumber": "350-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "350-RCGHPNL36",
      "LongItemNumber": "350-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCGHRM36",
      "ItemNumber": "350-RCGHRM36",
      "LongItemNumber": "350-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS36",
      "ItemNumber": "350-RCSMS36",
      "LongItemNumber": "350-RCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "RCSMS42",
      "ItemNumber": "350-RCSMS42",
      "LongItemNumber": "350-RCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPCR36",
      "ItemNumber": "350-ROPCR36",
      "LongItemNumber": "350-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS36",
      "ItemNumber": "350-ROPMS36",
      "LongItemNumber": "350-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPMS42",
      "ItemNumber": "350-ROPMS42",
      "LongItemNumber": "350-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPPNL36",
      "ItemNumber": "350-ROPPNL36",
      "LongItemNumber": "350-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 350,
      "Option Code": "ROPRM36",
      "ItemNumber": "350-ROPRM36",
      "LongItemNumber": "350-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36",
      "ItemNumber": "400-LBHCR36",
      "LongItemNumber": "400-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "400-LBHCR36TR",
      "LongItemNumber": "400-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36",
      "ItemNumber": "400-LBHMS36",
      "LongItemNumber": "400-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "400-LBHMS36TR",
      "LongItemNumber": "400-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42",
      "ItemNumber": "400-LBHMS42",
      "LongItemNumber": "400-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "400-LBHMS42TR",
      "LongItemNumber": "400-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36",
      "ItemNumber": "400-LBHPNL36",
      "LongItemNumber": "400-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "400-LBHPNL36TR",
      "LongItemNumber": "400-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36",
      "ItemNumber": "400-LBHRM36",
      "LongItemNumber": "400-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "400-LBHRM36TR",
      "LongItemNumber": "400-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36",
      "ItemNumber": "400-LCGHCR36",
      "LongItemNumber": "400-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "400-LCGHCR36TR",
      "LongItemNumber": "400-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36",
      "ItemNumber": "400-LCGHMS36",
      "LongItemNumber": "400-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "400-LCGHMS36TR",
      "LongItemNumber": "400-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42",
      "ItemNumber": "400-LCGHMS42",
      "LongItemNumber": "400-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "400-LCGHMS42TR",
      "LongItemNumber": "400-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "400-LCGHPNL36",
      "LongItemNumber": "400-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "400-LCGHPNL36TR",
      "LongItemNumber": "400-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36",
      "ItemNumber": "400-LCGHRM36",
      "LongItemNumber": "400-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "400-LCGHRM36TR",
      "LongItemNumber": "400-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36",
      "ItemNumber": "400-LOPCR36",
      "LongItemNumber": "400-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "400-LOPCR36TR",
      "LongItemNumber": "400-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36",
      "ItemNumber": "400-LOPMS36",
      "LongItemNumber": "400-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "400-LOPMS36TR",
      "LongItemNumber": "400-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42",
      "ItemNumber": "400-LOPMS42",
      "LongItemNumber": "400-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "400-LOPMS42TR",
      "LongItemNumber": "400-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36",
      "ItemNumber": "400-LOPPNL36",
      "LongItemNumber": "400-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "400-LOPPNL36TR",
      "LongItemNumber": "400-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36",
      "ItemNumber": "400-LOPRM36",
      "LongItemNumber": "400-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "400-LOPRM36TR",
      "LongItemNumber": "400-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72",
      "ItemNumber": "400-PBHCR72",
      "LongItemNumber": "400-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "400-PBHCR72TR",
      "LongItemNumber": "400-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72",
      "ItemNumber": "400-PBHMS72",
      "LongItemNumber": "400-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "400-PBHMS72TR",
      "LongItemNumber": "400-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72",
      "ItemNumber": "400-PBHPNL72",
      "LongItemNumber": "400-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "400-PBHPNL72TR",
      "LongItemNumber": "400-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72",
      "ItemNumber": "400-PBHRM72",
      "LongItemNumber": "400-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "400-PBHRM72TR",
      "LongItemNumber": "400-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72",
      "ItemNumber": "400-PCEMS72",
      "LongItemNumber": "400-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "400-PCEMS72TR",
      "LongItemNumber": "400-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72",
      "ItemNumber": "400-PCGHCR72",
      "LongItemNumber": "400-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "400-PCGHCR72TR",
      "LongItemNumber": "400-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72",
      "ItemNumber": "400-PCGHMS72",
      "LongItemNumber": "400-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "400-PCGHMS72TR",
      "LongItemNumber": "400-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "400-PCGHPNL72",
      "LongItemNumber": "400-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "400-PCGHPNL72TR",
      "LongItemNumber": "400-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72",
      "ItemNumber": "400-PCGHRM72",
      "LongItemNumber": "400-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "400-PCGHRM72TR",
      "LongItemNumber": "400-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72",
      "ItemNumber": "400-POPCR72",
      "LongItemNumber": "400-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPCR72TR",
      "ItemNumber": "400-POPCR72TR",
      "LongItemNumber": "400-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72",
      "ItemNumber": "400-POPMS72",
      "LongItemNumber": "400-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPMS72TR",
      "ItemNumber": "400-POPMS72TR",
      "LongItemNumber": "400-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72",
      "ItemNumber": "400-POPPNL72",
      "LongItemNumber": "400-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "400-POPPNL72TR",
      "LongItemNumber": "400-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72",
      "ItemNumber": "400-POPRM72",
      "LongItemNumber": "400-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "POPRM72TR",
      "ItemNumber": "400-POPRM72TR",
      "LongItemNumber": "400-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36",
      "ItemNumber": "400-RBHCR36",
      "LongItemNumber": "400-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "400-RBHCR36TR",
      "LongItemNumber": "400-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36",
      "ItemNumber": "400-RBHMS36",
      "LongItemNumber": "400-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "400-RBHMS36TR",
      "LongItemNumber": "400-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42",
      "ItemNumber": "400-RBHMS42",
      "LongItemNumber": "400-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "400-RBHMS42TR",
      "LongItemNumber": "400-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36",
      "ItemNumber": "400-RBHPNL36",
      "LongItemNumber": "400-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "400-RBHPNL36TR",
      "LongItemNumber": "400-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36",
      "ItemNumber": "400-RBHRM36",
      "LongItemNumber": "400-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "400-RBHRM36TR",
      "LongItemNumber": "400-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36",
      "ItemNumber": "400-RCGHCR36",
      "LongItemNumber": "400-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "400-RCGHCR36TR",
      "LongItemNumber": "400-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36",
      "ItemNumber": "400-RCGHMS36",
      "LongItemNumber": "400-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "400-RCGHMS36TR",
      "LongItemNumber": "400-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42",
      "ItemNumber": "400-RCGHMS42",
      "LongItemNumber": "400-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "400-RCGHMS42TR",
      "LongItemNumber": "400-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "400-RCGHPNL36",
      "LongItemNumber": "400-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "400-RCGHPNL36TR",
      "LongItemNumber": "400-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36",
      "ItemNumber": "400-RCGHRM36",
      "LongItemNumber": "400-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "400-RCGHRM36TR",
      "LongItemNumber": "400-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36",
      "ItemNumber": "400-ROPCR36",
      "LongItemNumber": "400-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "400-ROPCR36TR",
      "LongItemNumber": "400-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36",
      "ItemNumber": "400-ROPMS36",
      "LongItemNumber": "400-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "400-ROPMS36TR",
      "LongItemNumber": "400-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42",
      "ItemNumber": "400-ROPMS42",
      "LongItemNumber": "400-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "400-ROPMS42TR",
      "LongItemNumber": "400-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36",
      "ItemNumber": "400-ROPPNL36",
      "LongItemNumber": "400-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "400-ROPPNL36TR",
      "LongItemNumber": "400-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36",
      "ItemNumber": "400-ROPRM36",
      "LongItemNumber": "400-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "400-ROPRM36TR",
      "LongItemNumber": "400-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36",
      "ItemNumber": "400-SCEMS36",
      "LongItemNumber": "400-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "400-SCEMS36TR",
      "LongItemNumber": "400-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42",
      "ItemNumber": "400-SCEMS42",
      "LongItemNumber": "400-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 400,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "400-SCEMS42TR",
      "LongItemNumber": "400-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36",
      "ItemNumber": "450-LBHCR36",
      "LongItemNumber": "450-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "450-LBHCR36TR",
      "LongItemNumber": "450-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36",
      "ItemNumber": "450-LBHMS36",
      "LongItemNumber": "450-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "450-LBHMS36TR",
      "LongItemNumber": "450-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42",
      "ItemNumber": "450-LBHMS42",
      "LongItemNumber": "450-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "450-LBHMS42TR",
      "LongItemNumber": "450-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36",
      "ItemNumber": "450-LBHPNL36",
      "LongItemNumber": "450-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "450-LBHPNL36TR",
      "LongItemNumber": "450-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36",
      "ItemNumber": "450-LBHRM36",
      "LongItemNumber": "450-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "450-LBHRM36TR",
      "LongItemNumber": "450-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36",
      "ItemNumber": "450-LCGHCR36",
      "LongItemNumber": "450-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "450-LCGHCR36TR",
      "LongItemNumber": "450-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36",
      "ItemNumber": "450-LCGHMS36",
      "LongItemNumber": "450-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "450-LCGHMS36TR",
      "LongItemNumber": "450-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42",
      "ItemNumber": "450-LCGHMS42",
      "LongItemNumber": "450-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "450-LCGHMS42TR",
      "LongItemNumber": "450-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "450-LCGHPNL36",
      "LongItemNumber": "450-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "450-LCGHPNL36TR",
      "LongItemNumber": "450-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36",
      "ItemNumber": "450-LCGHRM36",
      "LongItemNumber": "450-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "450-LCGHRM36TR",
      "LongItemNumber": "450-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36",
      "ItemNumber": "450-LOPCR36",
      "LongItemNumber": "450-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "450-LOPCR36TR",
      "LongItemNumber": "450-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36",
      "ItemNumber": "450-LOPMS36",
      "LongItemNumber": "450-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "450-LOPMS36TR",
      "LongItemNumber": "450-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42",
      "ItemNumber": "450-LOPMS42",
      "LongItemNumber": "450-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "450-LOPMS42TR",
      "LongItemNumber": "450-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36",
      "ItemNumber": "450-LOPPNL36",
      "LongItemNumber": "450-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "450-LOPPNL36TR",
      "LongItemNumber": "450-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36",
      "ItemNumber": "450-LOPRM36",
      "LongItemNumber": "450-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "450-LOPRM36TR",
      "LongItemNumber": "450-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72",
      "ItemNumber": "450-PBHCR72",
      "LongItemNumber": "450-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "450-PBHCR72TR",
      "LongItemNumber": "450-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72",
      "ItemNumber": "450-PBHMS72",
      "LongItemNumber": "450-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "450-PBHMS72TR",
      "LongItemNumber": "450-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72",
      "ItemNumber": "450-PBHPNL72",
      "LongItemNumber": "450-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "450-PBHPNL72TR",
      "LongItemNumber": "450-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72",
      "ItemNumber": "450-PBHRM72",
      "LongItemNumber": "450-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "450-PBHRM72TR",
      "LongItemNumber": "450-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72",
      "ItemNumber": "450-PCEMS72",
      "LongItemNumber": "450-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "450-PCEMS72TR",
      "LongItemNumber": "450-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72",
      "ItemNumber": "450-PCGHCR72",
      "LongItemNumber": "450-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "450-PCGHCR72TR",
      "LongItemNumber": "450-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72",
      "ItemNumber": "450-PCGHMS72",
      "LongItemNumber": "450-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "450-PCGHMS72TR",
      "LongItemNumber": "450-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "450-PCGHPNL72",
      "LongItemNumber": "450-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "450-PCGHPNL72TR",
      "LongItemNumber": "450-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72",
      "ItemNumber": "450-PCGHRM72",
      "LongItemNumber": "450-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "450-PCGHRM72TR",
      "LongItemNumber": "450-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72",
      "ItemNumber": "450-POPCR72",
      "LongItemNumber": "450-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPCR72TR",
      "ItemNumber": "450-POPCR72TR",
      "LongItemNumber": "450-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72",
      "ItemNumber": "450-POPMS72",
      "LongItemNumber": "450-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPMS72TR",
      "ItemNumber": "450-POPMS72TR",
      "LongItemNumber": "450-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72",
      "ItemNumber": "450-POPPNL72",
      "LongItemNumber": "450-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "450-POPPNL72TR",
      "LongItemNumber": "450-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72",
      "ItemNumber": "450-POPRM72",
      "LongItemNumber": "450-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "POPRM72TR",
      "ItemNumber": "450-POPRM72TR",
      "LongItemNumber": "450-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36",
      "ItemNumber": "450-RBHCR36",
      "LongItemNumber": "450-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "450-RBHCR36TR",
      "LongItemNumber": "450-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36",
      "ItemNumber": "450-RBHMS36",
      "LongItemNumber": "450-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "450-RBHMS36TR",
      "LongItemNumber": "450-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42",
      "ItemNumber": "450-RBHMS42",
      "LongItemNumber": "450-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "450-RBHMS42TR",
      "LongItemNumber": "450-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36",
      "ItemNumber": "450-RBHPNL36",
      "LongItemNumber": "450-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "450-RBHPNL36TR",
      "LongItemNumber": "450-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36",
      "ItemNumber": "450-RBHRM36",
      "LongItemNumber": "450-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "450-RBHRM36TR",
      "LongItemNumber": "450-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36",
      "ItemNumber": "450-RCGHCR36",
      "LongItemNumber": "450-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "450-RCGHCR36TR",
      "LongItemNumber": "450-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36",
      "ItemNumber": "450-RCGHMS36",
      "LongItemNumber": "450-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "450-RCGHMS36TR",
      "LongItemNumber": "450-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42",
      "ItemNumber": "450-RCGHMS42",
      "LongItemNumber": "450-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "450-RCGHMS42TR",
      "LongItemNumber": "450-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "450-RCGHPNL36",
      "LongItemNumber": "450-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "450-RCGHPNL36TR",
      "LongItemNumber": "450-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36",
      "ItemNumber": "450-RCGHRM36",
      "LongItemNumber": "450-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "450-RCGHRM36TR",
      "LongItemNumber": "450-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36",
      "ItemNumber": "450-ROPCR36",
      "LongItemNumber": "450-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "450-ROPCR36TR",
      "LongItemNumber": "450-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36",
      "ItemNumber": "450-ROPMS36",
      "LongItemNumber": "450-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "450-ROPMS36TR",
      "LongItemNumber": "450-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42",
      "ItemNumber": "450-ROPMS42",
      "LongItemNumber": "450-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "450-ROPMS42TR",
      "LongItemNumber": "450-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36",
      "ItemNumber": "450-ROPPNL36",
      "LongItemNumber": "450-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "450-ROPPNL36TR",
      "LongItemNumber": "450-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36",
      "ItemNumber": "450-ROPRM36",
      "LongItemNumber": "450-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "450-ROPRM36TR",
      "LongItemNumber": "450-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36",
      "ItemNumber": "450-SCEMS36",
      "LongItemNumber": "450-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "450-SCEMS36TR",
      "LongItemNumber": "450-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42",
      "ItemNumber": "450-SCEMS42",
      "LongItemNumber": "450-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 450,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "450-SCEMS42TR",
      "LongItemNumber": "450-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36",
      "ItemNumber": "451-LBHCR36",
      "LongItemNumber": "451-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "451-LBHCR36TR",
      "LongItemNumber": "451-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36",
      "ItemNumber": "451-LBHMS36",
      "LongItemNumber": "451-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "451-LBHMS36TR",
      "LongItemNumber": "451-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42",
      "ItemNumber": "451-LBHMS42",
      "LongItemNumber": "451-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "451-LBHMS42TR",
      "LongItemNumber": "451-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36",
      "ItemNumber": "451-LBHPNL36",
      "LongItemNumber": "451-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "451-LBHPNL36TR",
      "LongItemNumber": "451-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36",
      "ItemNumber": "451-LBHRM36",
      "LongItemNumber": "451-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "451-LBHRM36TR",
      "LongItemNumber": "451-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36",
      "ItemNumber": "451-LCGHCR36",
      "LongItemNumber": "451-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "451-LCGHCR36TR",
      "LongItemNumber": "451-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36",
      "ItemNumber": "451-LCGHMS36",
      "LongItemNumber": "451-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "451-LCGHMS36TR",
      "LongItemNumber": "451-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42",
      "ItemNumber": "451-LCGHMS42",
      "LongItemNumber": "451-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "451-LCGHMS42TR",
      "LongItemNumber": "451-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "451-LCGHPNL36",
      "LongItemNumber": "451-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "451-LCGHPNL36TR",
      "LongItemNumber": "451-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36",
      "ItemNumber": "451-LCGHRM36",
      "LongItemNumber": "451-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "451-LCGHRM36TR",
      "LongItemNumber": "451-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36",
      "ItemNumber": "451-LOPCR36",
      "LongItemNumber": "451-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "451-LOPCR36TR",
      "LongItemNumber": "451-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36",
      "ItemNumber": "451-LOPMS36",
      "LongItemNumber": "451-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "451-LOPMS36TR",
      "LongItemNumber": "451-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42",
      "ItemNumber": "451-LOPMS42",
      "LongItemNumber": "451-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "451-LOPMS42TR",
      "LongItemNumber": "451-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36",
      "ItemNumber": "451-LOPPNL36",
      "LongItemNumber": "451-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "451-LOPPNL36TR",
      "LongItemNumber": "451-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36",
      "ItemNumber": "451-LOPRM36",
      "LongItemNumber": "451-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "451-LOPRM36TR",
      "LongItemNumber": "451-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72",
      "ItemNumber": "451-PBHCR72",
      "LongItemNumber": "451-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "451-PBHCR72TR",
      "LongItemNumber": "451-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72",
      "ItemNumber": "451-PBHMS72",
      "LongItemNumber": "451-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "451-PBHMS72TR",
      "LongItemNumber": "451-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72",
      "ItemNumber": "451-PBHPNL72",
      "LongItemNumber": "451-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "451-PBHPNL72TR",
      "LongItemNumber": "451-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72",
      "ItemNumber": "451-PBHRM72",
      "LongItemNumber": "451-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "451-PBHRM72TR",
      "LongItemNumber": "451-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72",
      "ItemNumber": "451-PCEMS72",
      "LongItemNumber": "451-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "451-PCEMS72TR",
      "LongItemNumber": "451-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72",
      "ItemNumber": "451-PCGHCR72",
      "LongItemNumber": "451-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "451-PCGHCR72TR",
      "LongItemNumber": "451-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72",
      "ItemNumber": "451-PCGHMS72",
      "LongItemNumber": "451-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "451-PCGHMS72TR",
      "LongItemNumber": "451-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "451-PCGHPNL72",
      "LongItemNumber": "451-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "451-PCGHPNL72TR",
      "LongItemNumber": "451-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72",
      "ItemNumber": "451-PCGHRM72",
      "LongItemNumber": "451-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "451-PCGHRM72TR",
      "LongItemNumber": "451-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72",
      "ItemNumber": "451-POPCR72",
      "LongItemNumber": "451-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPCR72TR",
      "ItemNumber": "451-POPCR72TR",
      "LongItemNumber": "451-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72",
      "ItemNumber": "451-POPMS72",
      "LongItemNumber": "451-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPMS72TR",
      "ItemNumber": "451-POPMS72TR",
      "LongItemNumber": "451-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72",
      "ItemNumber": "451-POPPNL72",
      "LongItemNumber": "451-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "451-POPPNL72TR",
      "LongItemNumber": "451-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72",
      "ItemNumber": "451-POPRM72",
      "LongItemNumber": "451-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "POPRM72TR",
      "ItemNumber": "451-POPRM72TR",
      "LongItemNumber": "451-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36",
      "ItemNumber": "451-RBHCR36",
      "LongItemNumber": "451-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "451-RBHCR36TR",
      "LongItemNumber": "451-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36",
      "ItemNumber": "451-RBHMS36",
      "LongItemNumber": "451-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "451-RBHMS36TR",
      "LongItemNumber": "451-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42",
      "ItemNumber": "451-RBHMS42",
      "LongItemNumber": "451-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "451-RBHMS42TR",
      "LongItemNumber": "451-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36",
      "ItemNumber": "451-RBHPNL36",
      "LongItemNumber": "451-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "451-RBHPNL36TR",
      "LongItemNumber": "451-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36",
      "ItemNumber": "451-RBHRM36",
      "LongItemNumber": "451-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "451-RBHRM36TR",
      "LongItemNumber": "451-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36",
      "ItemNumber": "451-RCGHCR36",
      "LongItemNumber": "451-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "451-RCGHCR36TR",
      "LongItemNumber": "451-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36",
      "ItemNumber": "451-RCGHMS36",
      "LongItemNumber": "451-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "451-RCGHMS36TR",
      "LongItemNumber": "451-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42",
      "ItemNumber": "451-RCGHMS42",
      "LongItemNumber": "451-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "451-RCGHMS42TR",
      "LongItemNumber": "451-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "451-RCGHPNL36",
      "LongItemNumber": "451-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "451-RCGHPNL36TR",
      "LongItemNumber": "451-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36",
      "ItemNumber": "451-RCGHRM36",
      "LongItemNumber": "451-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "451-RCGHRM36TR",
      "LongItemNumber": "451-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36",
      "ItemNumber": "451-ROPCR36",
      "LongItemNumber": "451-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "451-ROPCR36TR",
      "LongItemNumber": "451-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36",
      "ItemNumber": "451-ROPMS36",
      "LongItemNumber": "451-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "451-ROPMS36TR",
      "LongItemNumber": "451-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42",
      "ItemNumber": "451-ROPMS42",
      "LongItemNumber": "451-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "451-ROPMS42TR",
      "LongItemNumber": "451-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36",
      "ItemNumber": "451-ROPPNL36",
      "LongItemNumber": "451-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "451-ROPPNL36TR",
      "LongItemNumber": "451-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36",
      "ItemNumber": "451-ROPRM36",
      "LongItemNumber": "451-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "451-ROPRM36TR",
      "LongItemNumber": "451-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36",
      "ItemNumber": "451-SCEMS36",
      "LongItemNumber": "451-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "451-SCEMS36TR",
      "LongItemNumber": "451-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42",
      "ItemNumber": "451-SCEMS42",
      "LongItemNumber": "451-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 451,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "451-SCEMS42TR",
      "LongItemNumber": "451-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHCR36",
      "ItemNumber": "500-LBHCR36",
      "LongItemNumber": "500-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS36",
      "ItemNumber": "500-LBHMS36",
      "LongItemNumber": "500-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHMS42",
      "ItemNumber": "500-LBHMS42",
      "LongItemNumber": "500-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHPNL36",
      "ItemNumber": "500-LBHPNL36",
      "LongItemNumber": "500-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LBHRM36",
      "ItemNumber": "500-LBHRM36",
      "LongItemNumber": "500-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS36",
      "ItemNumber": "500-LCEMS36",
      "LongItemNumber": "500-LCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCEMS42",
      "ItemNumber": "500-LCEMS42",
      "LongItemNumber": "500-LCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHCR36",
      "ItemNumber": "500-LCGHCR36",
      "LongItemNumber": "500-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS36",
      "ItemNumber": "500-LCGHMS36",
      "LongItemNumber": "500-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHMS42",
      "ItemNumber": "500-LCGHMS42",
      "LongItemNumber": "500-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "500-LCGHPNL36",
      "LongItemNumber": "500-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCGHRM36",
      "ItemNumber": "500-LCGHRM36",
      "LongItemNumber": "500-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS36",
      "ItemNumber": "500-LCSMS36",
      "LongItemNumber": "500-LCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LCSMS42",
      "ItemNumber": "500-LCSMS42",
      "LongItemNumber": "500-LCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPCR36",
      "ItemNumber": "500-LOPCR36",
      "LongItemNumber": "500-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS36",
      "ItemNumber": "500-LOPMS36",
      "LongItemNumber": "500-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPMS42",
      "ItemNumber": "500-LOPMS42",
      "LongItemNumber": "500-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPPNL36",
      "ItemNumber": "500-LOPPNL36",
      "LongItemNumber": "500-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "LOPRM36",
      "ItemNumber": "500-LOPRM36",
      "LongItemNumber": "500-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHCR72",
      "ItemNumber": "500-PBHCR72",
      "LongItemNumber": "500-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHMS72",
      "ItemNumber": "500-PBHMS72",
      "LongItemNumber": "500-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHPNL72",
      "ItemNumber": "500-PBHPNL72",
      "LongItemNumber": "500-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PBHRM72",
      "ItemNumber": "500-PBHRM72",
      "LongItemNumber": "500-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCEMS72",
      "ItemNumber": "500-PCEMS72",
      "LongItemNumber": "500-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHCR72",
      "ItemNumber": "500-PCGHCR72",
      "LongItemNumber": "500-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHMS72",
      "ItemNumber": "500-PCGHMS72",
      "LongItemNumber": "500-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "500-PCGHPNL72",
      "LongItemNumber": "500-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCGHRM72",
      "ItemNumber": "500-PCGHRM72",
      "LongItemNumber": "500-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "PCSMS72",
      "ItemNumber": "500-PCSMS72",
      "LongItemNumber": "500-PCSMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPCR72",
      "ItemNumber": "500-POPCR72",
      "LongItemNumber": "500-POPCR72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPMS72",
      "ItemNumber": "500-POPMS72",
      "LongItemNumber": "500-POPMS72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPPNL72",
      "ItemNumber": "500-POPPNL72",
      "LongItemNumber": "500-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "POPRM72",
      "ItemNumber": "500-POPRM72",
      "LongItemNumber": "500-POPRM72-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHCR36",
      "ItemNumber": "500-RBHCR36",
      "LongItemNumber": "500-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS36",
      "ItemNumber": "500-RBHMS36",
      "LongItemNumber": "500-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHMS42",
      "ItemNumber": "500-RBHMS42",
      "LongItemNumber": "500-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHPNL36",
      "ItemNumber": "500-RBHPNL36",
      "LongItemNumber": "500-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RBHRM36",
      "ItemNumber": "500-RBHRM36",
      "LongItemNumber": "500-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS36",
      "ItemNumber": "500-RCEMS36",
      "LongItemNumber": "500-RCEMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCEMS42",
      "ItemNumber": "500-RCEMS42",
      "LongItemNumber": "500-RCEMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHCR36",
      "ItemNumber": "500-RCGHCR36",
      "LongItemNumber": "500-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS36",
      "ItemNumber": "500-RCGHMS36",
      "LongItemNumber": "500-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHMS42",
      "ItemNumber": "500-RCGHMS42",
      "LongItemNumber": "500-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "500-RCGHPNL36",
      "LongItemNumber": "500-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCGHRM36",
      "ItemNumber": "500-RCGHRM36",
      "LongItemNumber": "500-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS36",
      "ItemNumber": "500-RCSMS36",
      "LongItemNumber": "500-RCSMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "RCSMS42",
      "ItemNumber": "500-RCSMS42",
      "LongItemNumber": "500-RCSMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPCR36",
      "ItemNumber": "500-ROPCR36",
      "LongItemNumber": "500-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS36",
      "ItemNumber": "500-ROPMS36",
      "LongItemNumber": "500-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPMS42",
      "ItemNumber": "500-ROPMS42",
      "LongItemNumber": "500-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPPNL36",
      "ItemNumber": "500-ROPPNL36",
      "LongItemNumber": "500-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 500,
      "Option Code": "ROPRM36",
      "ItemNumber": "500-ROPRM36",
      "LongItemNumber": "500-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Door",
      "TypeId": 2
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36",
      "ItemNumber": "540-LBHCR36",
      "LongItemNumber": "540-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "540-LBHCR36TR",
      "LongItemNumber": "540-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36",
      "ItemNumber": "540-LBHMS36",
      "LongItemNumber": "540-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "540-LBHMS36TR",
      "LongItemNumber": "540-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42",
      "ItemNumber": "540-LBHMS42",
      "LongItemNumber": "540-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "540-LBHMS42TR",
      "LongItemNumber": "540-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36",
      "ItemNumber": "540-LBHPNL36",
      "LongItemNumber": "540-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "540-LBHPNL36TR",
      "LongItemNumber": "540-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36",
      "ItemNumber": "540-LBHRM36",
      "LongItemNumber": "540-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "540-LBHRM36TR",
      "LongItemNumber": "540-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36",
      "ItemNumber": "540-LCGHCR36",
      "LongItemNumber": "540-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "540-LCGHCR36TR",
      "LongItemNumber": "540-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36",
      "ItemNumber": "540-LCGHMS36",
      "LongItemNumber": "540-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "540-LCGHMS36TR",
      "LongItemNumber": "540-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42",
      "ItemNumber": "540-LCGHMS42",
      "LongItemNumber": "540-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "540-LCGHMS42TR",
      "LongItemNumber": "540-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "540-LCGHPNL36",
      "LongItemNumber": "540-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "540-LCGHPNL36TR",
      "LongItemNumber": "540-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36",
      "ItemNumber": "540-LCGHRM36",
      "LongItemNumber": "540-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "540-LCGHRM36TR",
      "LongItemNumber": "540-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36",
      "ItemNumber": "540-LOPCR36",
      "LongItemNumber": "540-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "540-LOPCR36TR",
      "LongItemNumber": "540-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36",
      "ItemNumber": "540-LOPMS36",
      "LongItemNumber": "540-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "540-LOPMS36TR",
      "LongItemNumber": "540-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42",
      "ItemNumber": "540-LOPMS42",
      "LongItemNumber": "540-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "540-LOPMS42TR",
      "LongItemNumber": "540-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36",
      "ItemNumber": "540-LOPPNL36",
      "LongItemNumber": "540-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "540-LOPPNL36TR",
      "LongItemNumber": "540-LOPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36",
      "ItemNumber": "540-LOPRM36",
      "LongItemNumber": "540-LOPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "LOPRM36TR",
      "ItemNumber": "540-LOPRM36TR",
      "LongItemNumber": "540-LOPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72",
      "ItemNumber": "540-PBHCR72",
      "LongItemNumber": "540-PBHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHCR72TR",
      "ItemNumber": "540-PBHCR72TR",
      "LongItemNumber": "540-PBHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72",
      "ItemNumber": "540-PBHMS72",
      "LongItemNumber": "540-PBHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHMS72TR",
      "ItemNumber": "540-PBHMS72TR",
      "LongItemNumber": "540-PBHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72",
      "ItemNumber": "540-PBHPNL72",
      "LongItemNumber": "540-PBHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHPNL72TR",
      "ItemNumber": "540-PBHPNL72TR",
      "LongItemNumber": "540-PBHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72",
      "ItemNumber": "540-PBHRM72",
      "LongItemNumber": "540-PBHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PBHRM72TR",
      "ItemNumber": "540-PBHRM72TR",
      "LongItemNumber": "540-PBHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72",
      "ItemNumber": "540-PCEMS72",
      "LongItemNumber": "540-PCEMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCEMS72TR",
      "ItemNumber": "540-PCEMS72TR",
      "LongItemNumber": "540-PCEMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72",
      "ItemNumber": "540-PCGHCR72",
      "LongItemNumber": "540-PCGHCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHCR72TR",
      "ItemNumber": "540-PCGHCR72TR",
      "LongItemNumber": "540-PCGHCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72",
      "ItemNumber": "540-PCGHMS72",
      "LongItemNumber": "540-PCGHMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHMS72TR",
      "ItemNumber": "540-PCGHMS72TR",
      "LongItemNumber": "540-PCGHMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72",
      "ItemNumber": "540-PCGHPNL72",
      "LongItemNumber": "540-PCGHPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHPNL72TR",
      "ItemNumber": "540-PCGHPNL72TR",
      "LongItemNumber": "540-PCGHPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72",
      "ItemNumber": "540-PCGHRM72",
      "LongItemNumber": "540-PCGHRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "PCGHRM72TR",
      "ItemNumber": "540-PCGHRM72TR",
      "LongItemNumber": "540-PCGHRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72",
      "ItemNumber": "540-POPCR72",
      "LongItemNumber": "540-POPCR72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPCR72TR",
      "ItemNumber": "540-POPCR72TR",
      "LongItemNumber": "540-POPCR72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72",
      "ItemNumber": "540-POPMS72",
      "LongItemNumber": "540-POPMS72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPMS72TR",
      "ItemNumber": "540-POPMS72TR",
      "LongItemNumber": "540-POPMS72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72",
      "ItemNumber": "540-POPPNL72",
      "LongItemNumber": "540-POPPNL72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPPNL72TR",
      "ItemNumber": "540-POPPNL72TR",
      "LongItemNumber": "540-POPPNL72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72",
      "ItemNumber": "540-POPRM72",
      "LongItemNumber": "540-POPRM72-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "POPRM72TR",
      "ItemNumber": "540-POPRM72TR",
      "LongItemNumber": "540-POPRM72TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36",
      "ItemNumber": "540-RBHCR36",
      "LongItemNumber": "540-RBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHCR36TR",
      "ItemNumber": "540-RBHCR36TR",
      "LongItemNumber": "540-RBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36",
      "ItemNumber": "540-RBHMS36",
      "LongItemNumber": "540-RBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS36TR",
      "ItemNumber": "540-RBHMS36TR",
      "LongItemNumber": "540-RBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42",
      "ItemNumber": "540-RBHMS42",
      "LongItemNumber": "540-RBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHMS42TR",
      "ItemNumber": "540-RBHMS42TR",
      "LongItemNumber": "540-RBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36",
      "ItemNumber": "540-RBHPNL36",
      "LongItemNumber": "540-RBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHPNL36TR",
      "ItemNumber": "540-RBHPNL36TR",
      "LongItemNumber": "540-RBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36",
      "ItemNumber": "540-RBHRM36",
      "LongItemNumber": "540-RBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RBHRM36TR",
      "ItemNumber": "540-RBHRM36TR",
      "LongItemNumber": "540-RBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36",
      "ItemNumber": "540-RCGHCR36",
      "LongItemNumber": "540-RCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHCR36TR",
      "ItemNumber": "540-RCGHCR36TR",
      "LongItemNumber": "540-RCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36",
      "ItemNumber": "540-RCGHMS36",
      "LongItemNumber": "540-RCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS36TR",
      "ItemNumber": "540-RCGHMS36TR",
      "LongItemNumber": "540-RCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42",
      "ItemNumber": "540-RCGHMS42",
      "LongItemNumber": "540-RCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHMS42TR",
      "ItemNumber": "540-RCGHMS42TR",
      "LongItemNumber": "540-RCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36",
      "ItemNumber": "540-RCGHPNL36",
      "LongItemNumber": "540-RCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHPNL36TR",
      "ItemNumber": "540-RCGHPNL36TR",
      "LongItemNumber": "540-RCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36",
      "ItemNumber": "540-RCGHRM36",
      "LongItemNumber": "540-RCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "RCGHRM36TR",
      "ItemNumber": "540-RCGHRM36TR",
      "LongItemNumber": "540-RCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36",
      "ItemNumber": "540-ROPCR36",
      "LongItemNumber": "540-ROPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPCR36TR",
      "ItemNumber": "540-ROPCR36TR",
      "LongItemNumber": "540-ROPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36",
      "ItemNumber": "540-ROPMS36",
      "LongItemNumber": "540-ROPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS36TR",
      "ItemNumber": "540-ROPMS36TR",
      "LongItemNumber": "540-ROPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42",
      "ItemNumber": "540-ROPMS42",
      "LongItemNumber": "540-ROPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPMS42TR",
      "ItemNumber": "540-ROPMS42TR",
      "LongItemNumber": "540-ROPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36",
      "ItemNumber": "540-ROPPNL36",
      "LongItemNumber": "540-ROPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPPNL36TR",
      "ItemNumber": "540-ROPPNL36TR",
      "LongItemNumber": "540-ROPPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36",
      "ItemNumber": "540-ROPRM36",
      "LongItemNumber": "540-ROPRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "ROPRM36TR",
      "ItemNumber": "540-ROPRM36TR",
      "LongItemNumber": "540-ROPRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36",
      "ItemNumber": "540-SCEMS36",
      "LongItemNumber": "540-SCEMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS36TR",
      "ItemNumber": "540-SCEMS36TR",
      "LongItemNumber": "540-SCEMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42",
      "ItemNumber": "540-SCEMS42",
      "LongItemNumber": "540-SCEMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 540,
      "Option Code": "SCEMS42TR",
      "ItemNumber": "540-SCEMS42TR",
      "LongItemNumber": "540-SCEMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36",
      "ItemNumber": "550-LBHCR36",
      "LongItemNumber": "550-LBHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHCR36TR",
      "ItemNumber": "550-LBHCR36TR",
      "LongItemNumber": "550-LBHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36",
      "ItemNumber": "550-LBHMS36",
      "LongItemNumber": "550-LBHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS36TR",
      "ItemNumber": "550-LBHMS36TR",
      "LongItemNumber": "550-LBHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42",
      "ItemNumber": "550-LBHMS42",
      "LongItemNumber": "550-LBHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHMS42TR",
      "ItemNumber": "550-LBHMS42TR",
      "LongItemNumber": "550-LBHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36",
      "ItemNumber": "550-LBHPNL36",
      "LongItemNumber": "550-LBHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHPNL36TR",
      "ItemNumber": "550-LBHPNL36TR",
      "LongItemNumber": "550-LBHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36",
      "ItemNumber": "550-LBHRM36",
      "LongItemNumber": "550-LBHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LBHRM36TR",
      "ItemNumber": "550-LBHRM36TR",
      "LongItemNumber": "550-LBHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36",
      "ItemNumber": "550-LCGHCR36",
      "LongItemNumber": "550-LCGHCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHCR36TR",
      "ItemNumber": "550-LCGHCR36TR",
      "LongItemNumber": "550-LCGHCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36",
      "ItemNumber": "550-LCGHMS36",
      "LongItemNumber": "550-LCGHMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS36TR",
      "ItemNumber": "550-LCGHMS36TR",
      "LongItemNumber": "550-LCGHMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42",
      "ItemNumber": "550-LCGHMS42",
      "LongItemNumber": "550-LCGHMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHMS42TR",
      "ItemNumber": "550-LCGHMS42TR",
      "LongItemNumber": "550-LCGHMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36",
      "ItemNumber": "550-LCGHPNL36",
      "LongItemNumber": "550-LCGHPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHPNL36TR",
      "ItemNumber": "550-LCGHPNL36TR",
      "LongItemNumber": "550-LCGHPNL36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36",
      "ItemNumber": "550-LCGHRM36",
      "LongItemNumber": "550-LCGHRM36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LCGHRM36TR",
      "ItemNumber": "550-LCGHRM36TR",
      "LongItemNumber": "550-LCGHRM36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36",
      "ItemNumber": "550-LOPCR36",
      "LongItemNumber": "550-LOPCR36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPCR36TR",
      "ItemNumber": "550-LOPCR36TR",
      "LongItemNumber": "550-LOPCR36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36",
      "ItemNumber": "550-LOPMS36",
      "LongItemNumber": "550-LOPMS36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS36TR",
      "ItemNumber": "550-LOPMS36TR",
      "LongItemNumber": "550-LOPMS36TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42",
      "ItemNumber": "550-LOPMS42",
      "LongItemNumber": "550-LOPMS42-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPMS42TR",
      "ItemNumber": "550-LOPMS42TR",
      "LongItemNumber": "550-LOPMS42TR-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-17",
      "FinishValue": 17,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-18",
      "FinishValue": 18,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-22",
      "FinishValue": 22,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-26",
      "FinishValue": 26,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-28",
      "FinishValue": 28,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-29",
      "FinishValue": 29,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36",
      "ItemNumber": "550-LOPPNL36",
      "LongItemNumber": "550-LOPPNL36-40",
      "FinishValue": 40,
      "Type": "Frame",
      "TypeId": 3
    },
    {
      "Item Series": 550,
      "Option Code": "LOPPNL36TR",
      "ItemNumber": "550-LOPPNL36TR",
      "LongItemNumber": "550-LOPPNL36TR-14",
      "FinishValue": 14,
      "Type": "Frame",
      "TypeId": 3
    }
  ]
  static getL() {
    return this.l;
  }
}


